export const HOME = '/';
export const ABOUT = '/about';
export const CONTACTUS = '/contact';
export const PRODUCTS = '/products';
export const PRODUCT = '/product/:id';
export const CHECKOUT = '/checkout';
export const LOGIN = '/login';
export const REGISTER = '/register';
export const DASHBOARD = '/account/dashboard';
export const PROFILE = '/account/profile';
export const ADDRESSES = '/account/addresses';
export const ORDERS = '/account/orders';
export const TRACKING = '/account/tracking';
export const WISHLIST = '/account/wishlist';
export const PAYMENTS = '/account/payments';
export const SUBSCRIPTIONS = '/account/subscriptions';
export const REVIEWS = '/account/reviews';
export const RETURNS = '/account/returns';
export const DOWNLOADS = '/account/downloads';
export const LOYALTY = '/account/loyalty';
export const COMMUNICATION = '/account/communication';
export const SECURITY = '/account/security';
export const PREFERENCES = '/account/preferences';
export const RECENTLY_VIEWED = '/account/recently-viewed';
export const RECOMMENDATIONS = '/account/recommendations';
export const BUSINESS_ACCOUNT = '/account/business';
export const ADDITIONAL_FEATURES = '/account/additional';
